module.exports = __webpack_public_path__ + "static/media/wd7.df0b1ba8.jpeg";